import './App.css';
import { Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ContactPage from './pages/ContactPage';
import AboutUsPage from './pages/AboutUs';
import SustainabilityPage from './pages/Sustainability';
import NotFoundPage from './pages/NotFoundPage';
import Header from './Components/Header';
import Footer from './Components/Footer';
import ProductGrouseSatin from './pages/ProductGrouseSatin';
import ProductNFX from './pages/ProductNFX';
import ProductNFP from './pages/ProductNFP';
import ScrollToTop from './Components/ScrollToTop';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/about" element={<AboutUsPage />} />
          <Route path="/sustainability" element={<SustainabilityPage />} />
          <Route path="/product-grouse-satin" element={<ProductGrouseSatin />} />
          <Route path="/product-nfx" element={<ProductNFX />} />
          <Route path="/product-nfp" element={<ProductNFP />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;